"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordRestoreDto = void 0;
class PasswordRestoreDto {
    password;
    confirmPassword;
    token;
}
exports.PasswordRestoreDto = PasswordRestoreDto;
